import React from 'react'
import {Col, Descriptions, Divider, Row} from "antd";
import userDateFormatter from "../../services/formatters/userDateFormatter";
import {getRecipeById} from "../../services/serviceRecipe";
import {Table} from "react-bootstrap";


class ProductionDetailModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            recipe: {}
        }
    }

    componentDidMount() {
        getRecipeById(this.props.prodDetail.production.recipe.id)
            .then(({data}) => {
                this.setState({recipe: data})
            })
    }

    render() {
        return (
            <React.Fragment>
                <div style={{padding: '24px'}}>
                    <Row justify={"space-between"} align={"top"}>
                        <Col span={10}>
                            <Descriptions bordered>
                                <Descriptions.Item key={'prodNo'} label={'Üretim Numarası'}
                                                   span={3}>{this.props.prodDetail.production.productionNumber}</Descriptions.Item>
                                <Descriptions.Item key={'description'} label={'Müşteri'}
                                                   span={3}>{this.props.prodDetail.production.customer.name}</Descriptions.Item>
                                <Descriptions.Item key={'quantity'} label={'Adet'}
                                                   span={3}>{this.props.prodDetail.production.quantity}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                        <Col span={10}>
                            <Descriptions bordered>
                                <Descriptions.Item key={'lineName'} label={'Üretim Hattı'}
                                                   span={3}>{this.props.prodDetail.production.productionLine.name}</Descriptions.Item>
                                <Descriptions.Item key={'startDate'} label={'Başlangıç Tarihi'}
                                                   span={3}>{userDateFormatter(this.props.prodDetail.production.startDate)}</Descriptions.Item>
                                <Descriptions.Item key={'endDate'} label={'Bitiş Tarihi'}
                                                   span={3}>{userDateFormatter(this.props.prodDetail.production.endDate)}</Descriptions.Item>
                                <Descriptions.Item key={'Note'} label={'Üretim Notu'}
                                                   span={3}>{this.props.prodDetail.production.note}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <h3>Reçete Özeti</h3>
                            <Divider/>
                            <Descriptions
                                bordered
                            >
                                <Descriptions.Item
                                    key={'name'}
                                    label={'Reçete Adı'}>{this.props.prodDetail.production.recipe.name}</Descriptions.Item>
                                <Descriptions.Item
                                    key={'description'}
                                    label={'Reçete Açıklaması'}>{this.props.prodDetail.production.recipe.description}</Descriptions.Item>
                                <Descriptions.Item
                                    key={'createdBy'}
                                    label={'Reçeteyi Oluşturan'}>{this.props.prodDetail.production.recipe.createdBy}</Descriptions.Item>
                                <Descriptions.Item
                                    key={'date'}
                                    label={'Oluşturulma Tarihi'}>{userDateFormatter(this.props.prodDetail.production.recipe.createdDate)}</Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    {
                        this.state.recipe.recipe ?
                            <div style={{marginTop: '32px'}}>

                                <Row>
                                    <Col span={24}>
                                        <h3 style={{marginTop: '16px'}}>Reçete Malzeme Listesi</h3>
                                        <Divider/>
                                        <Table
                                            responsive
                                        >
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Stok</th>
                                                <th>Miktar</th>
                                                <th>Birim</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.recipe.billOfMaterials.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.stock.description}</td>
                                                            <td>{item.amount}</td>
                                                            <td>{item.stock.unit}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </div>
                            : null
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default ProductionDetailModal